import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightLeft,
  faTrashCan,
  faArrowDown,
  faArrowUp,
  faEye,
  faEyeSlash,
  faHand,
  faArrowsUpDownLeftRight,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { QuestionTypeEnum } from "../../../Constants";
import { Row, Form, Col, Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import {
  InputControl,
  InputValidationConstants,
  createOptionsFromEnum,
  SelectControl,
  CheckboxControl,
  PageHeader,
  NumberControl,
  Modal,
} from "wup-module1-base";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useFieldArray, useForm } from "react-hook-form";
import $ from "jquery";
import QuestionModal from "./QuestionModal";
import { add } from "date-fns";

function QuestionnaireDroppables({
  appendPages,
  updatePages,
  removePages,
  movePages,
  pagesFields,
  appendQuestions,
  updateQuestions,
  removeQuestions,
  moveQuestions,
  questionsFields,
  register,
  errors,
  getValues,
  questionnaireId,
  replaceQuestions,
}) {
  const [isEdit, setIsEdit] = useState(null);
  const [pageQuestion, setPageQuestion] = useState(null);
  const [questionToTransfer, setQuestionToTransfer] = useState(null);
  const [rearrangeQuestions, setRearrangeQuestions] = useState(false);
  const [iconsVisibility, setIconsVisibility] = useState([
    { visible: true, pageId: null },
  ]);

  useEffect(() => {
    if (rearrangeQuestions) {
      rearrangeQuestionsByPageOrder();
      setRearrangeQuestions(false);
    }
  }, [rearrangeQuestions]);

  useEffect(() => {
    if (pagesFields?.length > 0) {
      handlePageVisibility();
      rearrangeQuestionsByPageOrder();
    }
  }, [pagesFields]);

  const handlePageVisibility = () => {
    const pageIds = pagesFields.map((i) => i.id);
    const updatedVisibility = [];
    pageIds.forEach((pageId, idx) => {
      const currVisibility = iconsVisibility.find((i) => i.pageId === pageId);
      if (!!currVisibility) {
        currVisibility.pageId = pageId;
        updatedVisibility[idx] = currVisibility;
      } else {
        updatedVisibility[idx] = { visible: true, pageId: pageId };
      }
    });
    setIconsVisibility(updatedVisibility);
  };

  const rearrangeQuestionsByPageOrder = () => {
    const pageIds = pagesFields.map((i) => i.id);
    const newQuestionFields = [];
    pageIds.forEach((pageId) => {
      const currentPageQuestions = questionsFields.filter(
        (q) => q.pageId === pageId
      );
      newQuestionFields.push(...currentPageQuestions);
    });
    replaceQuestions(newQuestionFields);
  };

  const handlePageDrop = (droppedPage) => {
    if (!droppedPage.destination) return;
    if (droppedPage.destination.droppableId === "pageContainer") {
      movePages(droppedPage.source.index, droppedPage.destination.index);
    }
  };

  function checkRelatedIndexes(currentIdx, destinationIdx) {
    const currentQuestion = questionsFields[currentIdx];
    if (
      currentQuestion.relatedQuestions.length > 0 &&
      destinationIdx > currentIdx
    ) {
      const relatedQuestionIds = currentQuestion.relatedQuestions.map(
        (i) => i.id
      );
      const questionsBeetween = questionsFields.filter(
        (q, idx) => idx > currentIdx && idx <= destinationIdx
      );
      let isAnyAbove = questionsBeetween.find((i) =>
        relatedQuestionIds.includes(i.id)
      );
      if (!!isAnyAbove) {
        toast.warn(
          "Pytanie nadrzędne nie może znajdować się poniżej pytania z nim powiązanego!"
        );
        return true;
      }
    }
    if (!!currentQuestion.relatedQuestionId && destinationIdx < currentIdx) {
      const relatedIdx = questionsFields.indexOf(
        questionsFields.find((i) => i.id === currentQuestion.relatedQuestionId)
      );
      if (relatedIdx < currentIdx && relatedIdx >= destinationIdx) {
        toast.warn(
          "Pytanie powiązane nie może znajdować się wyżej od nadrzędnego!"
        );
        return true;
      }
    }
    return false;
  }

  const handleQuestionDrop = (droppedQuestion) => {
    if (!droppedQuestion.destination) return;
    if (droppedQuestion.destination.droppableId === "questionsContainer") {
      if (
        checkRelatedIndexes(
          droppedQuestion.source.index,
          droppedQuestion.destination.index
        )
      )
        return;
      moveQuestions(
        droppedQuestion.source.index,
        droppedQuestion.destination.index
      );
    }
  };

  const handlePageUp = (pageIdx) => {
    movePages(pageIdx, pageIdx - 1);
  };

  const handlePageDown = (pageIdx) => {
    movePages(pageIdx, pageIdx + 1);
  };

  const handleTransferButtonClick = () => {
    const pageIdx = parseInt(getValues("redirectNr"));
    const page = pagesFields[pageIdx - 1];
    if (page.id === questionToTransfer.pageId) {
      toast.info("Pytanie już znajduje się na danej stronie!");
      return;
    }
    if (questionToTransfer.relatedQuestions.length > 0) {
      //TODO ?
      //const allQuestionsToMove
    }
    const questionIdx = questionsFields.indexOf(questionToTransfer);
    questionsFields.splice(questionIdx, 1);

    removeQuestions(questionIdx);
    const updatedQuestion = { ...questionToTransfer };
    const currentPageQuestions = questionsFields.filter(
      (i) => i.pageId === page.id
    );
    updatedQuestion.pageId = page.id;
    updatedQuestion.order = currentPageQuestions.length + 1;
    appendQuestions(updatedQuestion);
    setRearrangeQuestions(true);
    toast.success(`Pomyślnie przeniesiono pytanie na stronę ${pageIdx}`);
    setQuestionToTransfer(null);
  };

  const showPage = (pageId, pageIdx) => {
    const updatedVisibility = [...iconsVisibility];
    updatedVisibility[pageIdx].visible = true;
    updatedVisibility[pageIdx].pageId = pageId;
    setIconsVisibility(updatedVisibility);
    $(`#page-content-${pageIdx}`).attr("hidden", false);
    $(`#page-row-${pageIdx}`).attr("hidden", false);
  };

  const hidePage = (pageId, pageIdx) => {
    const updatedVisibility = [...iconsVisibility];
    updatedVisibility[pageIdx].visible = false;
    updatedVisibility[pageIdx].pageId = pageId;
    setIconsVisibility(updatedVisibility);
    $(`#page-content-${pageIdx}`).attr("hidden", true);
    $(`#page-row-${pageIdx}`).attr("hidden", true);
  };

  const removePage = (pageIdx) => {
    const toReplace = questionsFields.filter(
      (i) => i.pageId !== pagesFields[pageIdx].id
    );
    replaceQuestions(toReplace);
    removePages(pageIdx);
  };

  const handlePageButtonClick = () => {
    const length = pagesFields.length;
    const page = {
      id: uuidv4(),
      questionnaireId: questionnaireId,
      name: null,
      order: length + 1,
    };
    appendPages(page);
  };

  const editQuestion = (question, idx) => {
    setIsEdit(true);
    // const toSelect = questionsFields.filter((i) => i.id !== question.id);
    // setQuestionsToSelect([...toSelect]);
    // const data = getValues();
    // const copiedQuestion = { ...question };
    // copiedQuestion.type = data.questions[idx].type;
    // copiedQuestion.name = data.questions[idx].name;
    setPageQuestion(question);
  };

  const removeQuestion = (question, idx) => {
    if (question.relatedQuestions?.length > 0)
      toast.warn(
        "Nie można usunąć pytań zawierających pytania powiązane. Aby je usunąć, usuń wszystkie skorelowane pytania."
      );
    else {
      if (!!question.relatedQuestionId) {
        const relatedQuestion = questionsFields.find(
          (i) => i.id === question.relatedQuestionId
        );
        const relatedIdx = questionsFields.indexOf(relatedQuestion);
        const toRemove = relatedQuestion.relatedQuestions.find(
          (i) => i.id === question.id
        );
        const toRemoveIdx = relatedQuestion.relatedQuestions.indexOf(toRemove);
        relatedQuestion.relatedQuestions.splice(toRemoveIdx, 1);
        updateQuestions(relatedIdx, relatedQuestion);
      }
      removeQuestions(idx);
    }
  };

  const addQuestion = (pageId) => {
    setIsEdit(false);
    const length = questionsFields.filter((i) => i.pageId === pageId).length;
    const question = {
      id: uuidv4(),
      pageId: pageId,
      name: null,
      type: null,
      description: null,
      content: null,
      order: length + 1,
      relatedQuestionId: null,
      relatedAnswerId: null,
      relatedQuestions: [],
      answers: [],
    };
    setPageQuestion(question);
  };

  return (
    <>
      <Row className="justify-content-center align-items-center pb-3">
        <Col md={"auto"}>
          <Button
            className="px-3"
            type="button"
            variant="primary"
            onClick={() => handlePageButtonClick()}
          >
            Dodaj stronę
          </Button>
        </Col>
      </Row>

      {pagesFields.length > 0 && (
        <DragDropContext onDragEnd={handlePageDrop} onDragUpdate={() => {}}>
          <Droppable droppableId="pageContainer">
            {(provided) => (
              <Card {...provided.droppableProps} ref={provided.innerRef}>
                <PageHeader
                  content={"Strony ankiety"}
                  customCss={"py-2 px-2"}
                />
                {pagesFields.map((page, index) => (
                  <Draggable key={page.id} draggableId={page.id} index={index}>
                    {(provided) => (
                      <>
                        <div
                          className="border droppable-page"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <Card.Header
                            className="d-flex justify-content-between align-items-center"
                            style={{ fontSize: "20px" }}
                          >
                            {`Strona ${index + 1}`}
                            <div {...provided.dragHandleProps}>
                              <FontAwesomeIcon
                                icon={faArrowsUpDownLeftRight}
                                className={`ml-2`}
                                title="Przeciągnij (zmień kolejność)"
                              />
                            </div>
                            {pagesFields.length < 2 ? (
                              <div
                                className="d-flex ml-auto"
                                // style={{ alignItems: "end", width: "80%" }}
                              >
                                {iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`show-icon-${index}`}
                                    icon={faEye}
                                    className={`mr-2 ${"color-success"}`}
                                    onClick={() => hidePage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                {!iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`hide-icon-${index}`}
                                    icon={faEyeSlash}
                                    className={`mr-2 ${"color-danger"}`}
                                    onClick={() => showPage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  className="color-danger"
                                  role="button"
                                  onClick={() => removePage(index)}
                                />
                              </div>
                            ) : index === 0 ? (
                              <div
                                className="d-flex ml-auto"
                                // style={{ alignItems: "end", width: "80%" }}
                              >
                                {iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`show-icon-${index}`}
                                    icon={faEye}
                                    className={`mr-2 ${"color-success"}`}
                                    onClick={() => hidePage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                {!iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`hide-icon-${index}`}
                                    icon={faEyeSlash}
                                    className={`mr-2 ${"color-danger"}`}
                                    onClick={() => showPage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                <FontAwesomeIcon
                                  icon={faArrowDown}
                                  className="mr-2 color-primary"
                                  onClick={() => handlePageDown(index)}
                                  role="button"
                                />
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  className="color-danger"
                                  role="button"
                                  onClick={() => removePage(index)}
                                />
                              </div>
                            ) : index === pagesFields.length - 1 ? (
                              <div
                                className="d-flex ml-auto"
                                // style={{ alignItems: "end", width: "80%" }}
                              >
                                {iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`show-icon-${index}`}
                                    icon={faEye}
                                    className={`mr-2 ${"color-success"}`}
                                    onClick={() => hidePage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                {!iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`hide-icon-${index}`}
                                    icon={faEyeSlash}
                                    className={`mr-2 ${"color-danger"}`}
                                    onClick={() => showPage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                <FontAwesomeIcon
                                  icon={faArrowUp}
                                  className="mr-2 color-primary"
                                  onClick={() => handlePageUp(index)}
                                  role="button"
                                />
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  className="color-danger"
                                  role="button"
                                  onClick={() => removePage(index)}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex ml-auto"
                                // style={{ alignItems: "end", width: "80%" }}
                              >
                                {iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`show-icon-${index}`}
                                    icon={faEye}
                                    className={`mr-2 ${"color-success"}`}
                                    onClick={() => hidePage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                {!iconsVisibility[index]?.visible && (
                                  <FontAwesomeIcon
                                    id={`hide-icon-${index}`}
                                    icon={faEyeSlash}
                                    className={`mr-2 ${"color-danger"}`}
                                    onClick={() => showPage(page.id, index)}
                                    role="button"
                                  />
                                )}
                                <FontAwesomeIcon
                                  icon={faArrowUp}
                                  className="mr-2 color-primary"
                                  onClick={() => handlePageUp(index)}
                                  role="button"
                                />
                                <FontAwesomeIcon
                                  icon={faArrowDown}
                                  className="mr-2 color-primary"
                                  onClick={() => handlePageDown(index)}
                                  role="button"
                                />
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  className="color-danger"
                                  onClick={() => removePage(index)}
                                  role="button"
                                />
                              </div>
                            )}
                          </Card.Header>
                          <Row
                            id={`page-row-${index}`}
                            className="py-2 px-1 m-2 no-select"
                          >
                            <Col md={12}>
                              <InputControl
                                id={`pages.${index}.name`}
                                label={"Nazwa"}
                                readOnly={false}
                                errors={errors}
                                refs={{
                                  ...register(`pages.${index}.name`, {
                                    required: InputValidationConstants.required,
                                  }),
                                }}
                              />
                            </Col>
                          </Row>
                          <Card.Body id={`page-content-${index}`}>
                            <p className="fw-700 mb-2">Zawartość strony</p>
                            <Card className={"droppable-card"}>
                              <Row className="justify-content-center align-items-center pb-3">
                                <Col md={"auto"}>
                                  <Button
                                    className="px-3"
                                    type="button"
                                    variant="primary"
                                    onClick={() => addQuestion(page.id)}
                                  >
                                    Dodaj pytanie / Treść
                                  </Button>
                                </Col>
                              </Row>
                              {questionsFields.some(
                                (i) => i.pageId === page.id
                              ) && (
                                <DragDropContext onDragEnd={handleQuestionDrop}>
                                  <Droppable droppableId={`questionsContainer`}>
                                    {(provided) => (
                                      <Card.Body
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                      >
                                        {questionsFields.map(
                                          (question, index) =>
                                            question.pageId === page.id ? (
                                              <Draggable
                                                key={question.id}
                                                draggableId={question.id}
                                                index={index}
                                              >
                                                {(provided) => (
                                                  <>
                                                    <Row
                                                      className="droppable-row py-2 px-4 m-2 no-select"
                                                      ref={provided.innerRef}
                                                      {...provided.dragHandleProps}
                                                      {...provided.draggableProps}
                                                    >
                                                      <Col md={1}>
                                                        <p>{`Pytanie ${
                                                          index + 1
                                                        }`}</p>
                                                      </Col>
                                                      <Col>
                                                        <InputControl
                                                          id={`questions.${index}.name`}
                                                          label={"Nazwa"}
                                                          readOnly={true}
                                                          errors={errors}
                                                          value={question.name}
                                                          refs={{
                                                            ...register(
                                                              `questions.${index}.name`,
                                                              {
                                                                // required:
                                                                //   InputValidationConstants.required,
                                                              }
                                                            ),
                                                          }}
                                                        />
                                                      </Col>
                                                      <Col md={4}>
                                                        <SelectControl
                                                          id={`questions.${index}.type`}
                                                          label={"Typ"}
                                                          errors={errors}
                                                          options={createOptionsFromEnum(
                                                            QuestionTypeEnum,
                                                            false
                                                          )}
                                                          value={question.type}
                                                          readOnly={true}
                                                          refs={{
                                                            ...register(
                                                              `questions.${index}.type`,
                                                              {
                                                                required:
                                                                  InputValidationConstants.required,
                                                              }
                                                            ),
                                                          }}
                                                        />
                                                      </Col>
                                                      <Col
                                                        md={"auto"}
                                                        className="d-flex"
                                                        style={{
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Button
                                                          variant="info"
                                                          style={{
                                                            marginTop:
                                                              "0.88rem",
                                                            marginRight:
                                                              "0.2rem",
                                                          }}
                                                          //className="mt-3 ml-2"
                                                          onClick={() =>
                                                            editQuestion(
                                                              question,
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            className="mr-2"
                                                            icon={faEdit}
                                                          />
                                                          Edytuj
                                                        </Button>
                                                        <Button
                                                          variant="secondary"
                                                          disabled={
                                                            !!question.relatedQuestionId ||
                                                            question
                                                              .relatedQuestions
                                                              ?.length > 0 ||
                                                            pagesFields?.length <
                                                              2
                                                          }
                                                          style={{
                                                            marginTop:
                                                              "0.88rem",
                                                            marginRight:
                                                              "0.2rem",
                                                          }}
                                                          //className="mt-3 ml-2"
                                                          onClick={() =>
                                                            setQuestionToTransfer(
                                                              question
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            className="mr-2"
                                                            icon={faRightLeft}
                                                          />
                                                          Przenieś na inną
                                                          stronę
                                                        </Button>

                                                        <Button
                                                          variant="danger"
                                                          style={{
                                                            marginTop:
                                                              "0.88rem",
                                                          }}
                                                          //className="mt-3 ml-2"
                                                          onClick={() =>
                                                            removeQuestion(
                                                              question,
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            className="mr-2"
                                                            icon={faTrashCan}
                                                          />
                                                          Usuń
                                                        </Button>
                                                      </Col>
                                                      {question.relatedQuestions
                                                        ?.length > 0 && (
                                                        <Col md={12}>
                                                          <i
                                                            style={{
                                                              fontWeight:
                                                                "lighter",
                                                            }}
                                                          >
                                                            Zawiera pytania
                                                            skorelowane
                                                          </i>
                                                        </Col>
                                                      )}
                                                      {!!question.relatedQuestionId && (
                                                        <Col md={12}>
                                                          <i
                                                            style={{
                                                              fontWeight:
                                                                "lighter",
                                                            }}
                                                          >
                                                            {`Powiązane z: '${
                                                              // questionsFields.find(
                                                              //   (i) =>
                                                              //     i.id ===
                                                              //     question.relatedQuestionId
                                                              // )?.name ??
                                                              `Pytanie ${
                                                                questionsFields.indexOf(
                                                                  questionsFields.find(
                                                                    (q) =>
                                                                      q.id ===
                                                                      question.relatedQuestionId
                                                                  )
                                                                ) + 1
                                                              }`
                                                            }'`}
                                                          </i>
                                                        </Col>
                                                      )}
                                                    </Row>
                                                  </>
                                                )}
                                              </Draggable>
                                            ) : null
                                        )}
                                        {provided.placeholder}
                                      </Card.Body>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              )}
                            </Card>
                          </Card.Body>
                        </div>
                      </>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </Card>
            )}
          </Droppable>
        </DragDropContext>
      )}
      <QuestionModal
        isEdit={isEdit}
        question={pageQuestion}
        setQuestion={setPageQuestion}
        appendQuestion={appendQuestions}
        updateQuestion={updateQuestions}
        removeQuestion={removeQuestions}
        questionFields={questionsFields}
        pageFields={pagesFields}
        replaceQuestions={replaceQuestions}
      />
      <Modal
        show={!!questionToTransfer}
        size={"sm"}
        title={`Przeniesienie pytania`}
        onConfirm={() => handleTransferButtonClick()}
        onCancel={() => setQuestionToTransfer(null)}
        confirmButtonText={"Przenieś"}
        confirmButtonDisabled={!getValues("redirectNr")}
        enforceFocus={true}
      >
        <Row>
          <Col md={12}>
            <NumberControl
              id={"redirectNr"}
              label={"Numer strony"}
              min={1}
              max={pagesFields.length}
              refs={{
                ...register("redirectNr", {
                  required: InputValidationConstants.required,
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default QuestionnaireDroppables;
